import { message, notification } from 'ant-design-vue';
import { NotificationOptions } from 'ant-design-vue/types/notification';
type type = 'success' | 'info' | 'warning' | 'warn' | 'error' | 'loading';
/**
 * @author guan
 * @description 消息总线
 */
export default class MessageBus {
    /** 消息内容 */
    readonly content = '默认值';
    /** 延时关闭时间 */
    readonly type: type = 'info';
    /**
     * @author guan
     * @description  全局提示
     * @return void
     * @param level 级别
     * @param content
     * @param duration
     */
    static Message(level: type, content: string, duration?: number) {
        message[level](content, duration);
    }
    /**
     * @author guan
     * @description 全局提醒框
     * @return void
     * @param level 级别
     * @param Config  通知框Options
     */
    static Notification(level: type, Config: NotificationOptions) {
        if (Object.prototype.hasOwnProperty.call(Config, 'duration')) {
            notification[level as keyof typeof notification](Config as never);
        } else notification[level as keyof typeof notification]({ ...Config, duration: 2 } as never);
    }
}
